import styled from "styled-components";
import { IMAGES } from "../../constants/images";
import Step from "../ui/Step";
import Map from "../ui/map/Map";

export default function MapSection({ isFullScreen, handleFullScreen, windowWidth }) {
  return (
    <MapContainer>
      <h2 className="faq_title">
        Safeguard your assets from wildfires by creating defensible space around them. Follow <span>these three easy steps</span> to visualize that space in 3D:
      </h2>
      <div className="stepper">
        <Step primary={"1"}>{`Enter your asset's \naddress or coordinates \nin the search bar`}</Step>
        <Step primary={"2"}>
          Click on <img src={IMAGES.STEP_FAQ_2} alt="draw asset contour" height="35" style={{ marginBottom: "-14px" }} />
          {`\nthen click each corner of the asset to outline it. ${windowWidth <= 769 ? "Click" : "Double-click"} to complete the contour`}
        </Step>
        <Step primary={"3"}>
          {`To inspect the defensible \nspace in 3D,  ${windowWidth <= 769 ? "place two \nfingers on the screen \nand " : "use"}`}
          {windowWidth <= 769 ? (
            <img src={IMAGES.STEP_FAQ_3_MOBILE} alt="click" height="35" style={{ marginBottom: "-14px", marginLeft: "-8px" }} />
          ) : (
            <img src={IMAGES.STEP_FAQ_3} alt="click" height="35" style={{ marginBottom: "-14px", marginLeft: "-8px" }} />
          )}
        </Step>
      </div>
      <Map isFullScreen={isFullScreen} handleFullScreen={handleFullScreen} />
      <p className="expand-info">
        Expand the view to full screen using the top-right symbol <img src={IMAGES.STEP_SCREEN} alt="click" height="35" style={{ marginBottom: "-14px" }} /> on the map
      </p>
    </MapContainer>
  );
}

const MapContainer = styled.section`
  .faq_title {
    margin: 25px 0;
    padding: 0;
    letter-spacing: 2px;
    font-size: 28px;
    font-weight: 400;
    line-height: 40px;
    span {
      color: rgba(0, 0, 255, 1);
    }
  }

  .expand-info {
    font-size: 20px;
    text-align: center;
    margin-top: 10px;
    letter-spacing: 1px;
  }

  .stepper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
    margin: 25px 0;
  }

  @media (max-width: 1203px) {
    .stepper > *:last-child {
      margin-inline: auto;
    }
  }

  @media (max-width: 814px) {
    .stepper > *:last-child {
      margin-inline: 0;
    }

    .stepper > *:nth-child(2) {
      margin-left: auto;
    }
  }

  @media (max-width: 475px) {
    .faq_title {
      font-size: 18px;
      letter-spacing: 1px;
      line-height: 26px;
    }

    .expand-info {
      font-size: 18px;
      text-align: left;
    }
  }
`;
